export default class Counter {
	constructor(el) {
		this.el = el;

		const raw = el.dataset.target.trim();
		const match = raw.match(/^([^0-9\-+]*?)\s*([\d]+(?:[.,]\d+)?)\s*(.*)$/);

		this.prefix = match ? match[1] : '';
		const number = match ? match[2].replace(',', '.') : '0';
		this.target = parseFloat(number);
		this.unit = match ? match[3] : '';

		this.duration = 1500;
		this.startTime = null;

		this.observe();
	}

	observe() {
		const observer = new IntersectionObserver((entries, obs) => {
			entries.forEach(entry => {
				if (entry.isIntersecting) {
					this.start();
					obs.unobserve(this.el);
				}
			});
		}, { threshold: 0.4 });

		observer.observe(this.el);
	}

	start() {
		requestAnimationFrame(this.animate.bind(this));
	}

	animate(time) {
		if (!this.startTime) this.startTime = time;
		const progress = Math.min((time - this.startTime) / this.duration, 1);

		const decimals = this.target % 1 !== 0 ? 1 : 0;
		const value = (progress * this.target).toFixed(decimals);

		this.el.textContent = this.prefix + value + this.unit;

		if (progress < 1) {
			requestAnimationFrame(this.animate.bind(this));
		} else {
			this.el.textContent = this.prefix + this.target + this.unit;
		}
	}
}
